import application from "stimulus_application";
import SlidesController from "./slides_controller";
import "./slides.css";

application.register("slides", SlidesController);
